import React from "react";
import { COURSE_PLAN_LABEL, isSafeHttpUrl } from "../utilities/coursePlan";

// Renders the course plan link (new tab), or `fallback` when there is no
// valid link — never an empty/unsafe <a>.
const CoursePlanLink = ({ href, children, fallback = null, className }) => {
    if (!isSafeHttpUrl(href)) return fallback;
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
            {children || COURSE_PLAN_LABEL}
        </a>
    );
};

export default CoursePlanLink;
